import { render, staticRenderFns } from "./floorplan.vue?vue&type=template&id=56967c4d"
import script from "./floorplan.vue?vue&type=script&lang=js"
export * from "./floorplan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports